import { Component, inject, input, output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CuiDialogService } from '@innersource/common-ui-components';
import { ToolJobService } from '../../../services/api-services/tools/tool-job.service';
import { JobLogsDialComponent } from '../../../utils/dialogues/job-logs-dial/job-logs-dial.component';
import { Tool, ToolJob } from '../../../utils/models/tool.models';
import { InputMapping } from '../../../utils/models/toolchain.models';
import {
  JobDetailDialogComponent,
  JobDetailsContentType,
} from '../job-detail-dialog/job-detail-dialog.component';
import { ParameterNodeComponent } from './parameter-node/parameter-node.component';
import { InputParameterNodeComponent } from './input-parameter-node/input-parameter-node.component';
import { ToolNodeComponent } from './tool-node/tool-node.component';
import { ResultNodeComponent } from './result-node/result-node.component';
import { JobTimelineSkeletonComponent } from './job-timeline-skeleton/job-timeline-skeleton.component';

@Component({
  selector: 'app-job-timeline',
  templateUrl: './job-timeline.component.html',
  styleUrls: ['./job-timeline.component.scss'],
  imports: [
    JobTimelineSkeletonComponent,
    ParameterNodeComponent,
    InputParameterNodeComponent,
    ToolNodeComponent,
    ResultNodeComponent,
  ],
})
export class JobTimelineComponent {
  /** Inputs. */
  readonly job = input<ToolJob>();
  readonly tool = input.required<Tool>();
  readonly disabled = input(false);
  readonly outputsToMap = input<InputMapping[]>([]);
  readonly startJob = input<(form: FormGroup) => Promise<void>>();
  readonly rerunStep = input<() => Promise<void>>();
  readonly isInitialLoading = input(false);

  /** Outputs. */
  readonly jobStarting = output<boolean>();

  /** Services. */
  private readonly dialog = inject(MatDialog);
  private readonly detailDialog = inject(CuiDialogService);
  private readonly toolJobService = inject(ToolJobService);

  /** Opens job parameters or results. */
  openDetails(job: ToolJob, content: JobDetailsContentType): void {
    this.detailDialog.open(JobDetailDialogComponent, {
      data: { toolJob: job, tool: this.tool(), content },
      size: 'big',
      width: 'fit-content',
      minWidth: 'min(45rem, calc(100vw - 3rem))',
      maxWidth: 'min(80rem, calc(100vw - 3rem))',
    });
  }

  /** Opens the selected job's logs. */
  async openLogs(jobId: number): Promise<void> {
    const logs = await this.toolJobService.getJobLogsById(jobId);
    this.dialog.open(JobLogsDialComponent, { data: logs });
  }
}
